import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom'; // capturar o ID

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import CodeIcon from '@mui/icons-material/Code';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { IconX } from '@tabler/icons';

import 'reactflow/dist/style.css';
import {
    Menu,
    MenuItem,
    ButtonGroup,
    TextField,
    DialogActions,
    DialogContent,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import api from '../../../../services/api';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { makeStyles } from '@mui/styles';
import './NodeStyle.css';
import Editor from '@monaco-editor/react';

// ---------- Codes ----------
export default function CodeBuilder({ open, onClose, idFlow, chatbotId }) {
    // console.log(`CodeBuilder - entrou - idFlow:${idFlow}`);
    const [app_id, setApp_id] = useState(null);
    const [codeFiles, setCodeFiles] = useState([]);
    const [selectedCode, setSelectedCode] = useState(null);
    const [code, setCode] = useState('');
    const [openNewCodeDialog, setOpenNewCodeDialog] = useState(false);
    const [newCodeName, setNewCodeName] = useState('');

    const [contextMenu, setContextMenu] = useState(null);
    const [contextFile, setContextFile] = useState(null);

    const [openRenameDialog, setOpenRenameDialog] = useState(false);
    const [renameName, setRenameName] = useState('');

    const handleSelectedFileCode = (file) => {
        setSelectedCode(file);
        console.log(`selecionou file: ${JSON.stringify(file)}`);
        setCode(file.code);
    };

    const loadApps = async () => {
        try {
            if (!idFlow) return;
            const res = await api.get(`v1/apps/default/`);
            if (res.data) {
                setApp_id(res.data.app.id);
            }
        } catch (err) {
            console.error(`loadCodes - erro: ${JSON.stringify(err)}`);
        }
    };

    const loadCodes = async () => {
        if (!app_id) return;
        try {
            if (!idFlow) return;
            const res = await api.get(`v1/apps/${app_id}/chatbots/${chatbotId}/flows/${idFlow}/actions/`);
            if (res.data) {
                setCodeFiles(res.data);
            }
        } catch (err) {
            console.error(`loadCodes - erro: ${JSON.stringify(err)}`);
        }
    };

    useEffect(() => {
        if (open && idFlow) {
            loadApps();
        }
    }, [open, idFlow]);

    useEffect(() => {
        if (!open || !idFlow || !app_id) return;
        loadCodes();
    }, [open, idFlow, app_id]);

    // useEffect(() => {
    //     if (!code) return;
    //     setCode(null);
    // }, [codeDrawerOpen]);

    // const createNewCodeFile = async () => {
    //     try {
    //         const payload = {
    //             name: 'sem_nome',
    //             description: '',
    //             type: 'code',
    //             scope: 'flow',
    //             code: ''
    //         };

    //         const res = await api.post(`v1/apps/123/chatbots/1/flows/${idFlow}/actions/`, payload);
    //         if (res.data) {
    //             setCodeFiles((prev) => [...prev, res.data]);
    //         }
    //     } catch (err) {
    //         console.error(`createNewCodeFile - erro: ${JSON.stringify(err)}`);
    //     }
    // };

    const handleCreateCode = async () => {
        try {
            const formattedName = newCodeName.trim().replace(/\s+/g, '_');

            const payload = {
                name: formattedName,
                description: '',
                type: 'code',
                scope: 'flow',
                code: `// Você pode acessar:\n// user, session, temp, event\n\n`
            };

            console.log(`handleCreateCode - payload: ${JSON.stringify(payload)}`);

            const res = await api.post(`v1/apps/${app_id}/chatbots/${chatbotId}/flows/${idFlow}/actions/`, payload);

            setCodeFiles((prev) => [...prev, res.data]);
            setOpenNewCodeDialog(false);
            setSelectedCode(res.data);
            setCode(res.data.code);
            setNewCodeName('');
        } catch (err) {
            console.error('Erro ao criar código', err);
        }
    };

    const saveCodeFile = async () => {
        try {
            if (!idFlow) return;
            const payload = {
                code: code
            };
            const res = await api.put(`v1/apps/${app_id}/chatbots/${chatbotId}/flows/${idFlow}/actions/${selectedCode.id}/`, payload);
            if (res.data) {
                setCodeFiles((prev) => prev.map((file) => (file.id === selectedCode.id ? res.data : file)));

                setSelectedCode(null); // fecha o dialog
            }
        } catch (err) {
            console.error(`saveCodeFile - erro: ${JSON.stringify(err)}`);
        }
    };

    const deleteCodeFile = async () => {
        try {
            if (!idFlow) return;
            const res = await api.delete(`v1/apps/${app_id}/chatbots/${chatbotId}/flows/${idFlow}/actions/${selectedCode.id}/`);
            if (res.data) {
                console.log(`deleteCodeFile - código deletado`);
                setSelectedCode(null);
            }
        } catch (err) {
            console.error(`deleteCodeFile - erro: ${JSON.stringify(err)}`);
        }
    };

    const handleCloseCodeEditor = () => {
        setSelectedCode(null);
    };

    const handleRenameCode = async () => {
        try {
            const res = await api.put(`v1/apps/${app_id}/chatbots/${chatbotId}/flows/${idFlow}/actions/${contextFile.id}/`, {
                name: renameName
            });

            setCodeFiles((prev) => prev.map((f) => (f.id === contextFile.id ? res.data : f)));

            setOpenRenameDialog(false);
        } catch (err) {
            console.error('Erro ao renomear', err);
        }
    };

    const handleDeleteCode = async (file) => {
        try {
            await api.delete(`v1/apps/${app_id}/chatbots/${chatbotId}/flows/${idFlow}/actions/${file.id}/`);

            setCodeFiles((prev) => prev.filter((f) => f.id !== file.id));

            if (selectedCode?.id === file.id) {
                setSelectedCode(null);
            }
        } catch (err) {
            console.error('Erro ao excluir código', err);
        }
    };

    return (
        <>
            {/* Drawer codigo (left) */}
            <Drawer
                anchor="left"
                open={open}
                onClose={onClose}
                PaperProps={{
                    sx: {
                        width: 380,
                        backgroundColor: '#1e1e1e',
                        color: '#fff',
                        borderRight: '1px solid #2c2c2c'
                    }
                }}
            >
                {/* Header */}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    px={2}
                    py={1.5}
                    sx={{ borderBottom: '1px solid #2c2c2c' }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        {/* <CodeIcon fontSize="small" /> */}
                        <Typography color="#FFFFFF" variant="h6">
                            Arquivos de Códigos
                        </Typography>
                    </Box>

                    <IconButton size="small" onClick={onClose}>
                        <IconX fontSize="small" color="#FFFFFF" />
                    </IconButton>
                </Box>

                {/* Lista de arquivos */}
                <Box sx={{ p: 1, overflowY: 'auto', flex: 1 }}>
                    {codeFiles.map((file) => {
                        const selected = selectedCode?.id === file.id;

                        return (
                            <Box
                                key={file.id}
                                onClick={() => handleSelectedFileCode(file)}
                                onContextMenu={(e) => {
                                    e.preventDefault();
                                    setContextMenu({
                                        mouseX: e.clientX + 2,
                                        mouseY: e.clientY - 6
                                    });
                                    setContextFile(file);
                                }}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    px: 1.5,
                                    py: 1,
                                    mb: 0.5,
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                    backgroundColor: selected ? '#2e7d32' : 'transparent',
                                    color: selected ? '#fff' : '#ccc',
                                    '&:hover': {
                                        backgroundColor: selected ? '#2e7d32' : '#2a2a2a'
                                    }
                                }}
                            >
                                <CodeIcon fontSize="small" />
                                <Typography variant="body2" color="#FFFFFF" noWrap>
                                    {file.name}.js
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>

                <Menu
                    open={Boolean(contextMenu)}
                    onClose={() => setContextMenu(null)}
                    anchorReference="anchorPosition"
                    anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
                >
                    <MenuItem
                        onClick={() => {
                            setRenameName(contextFile.name);
                            setOpenRenameDialog(true);
                            setContextMenu(null);
                        }}
                    >
                        ✏️ Renomear
                    </MenuItem>

                    <MenuItem
                        onClick={() => {
                            handleDeleteCode(contextFile);
                            setContextMenu(null);
                        }}
                        sx={{ color: 'error.main' }}
                    >
                        🗑️ Excluir
                    </MenuItem>
                </Menu>

                <Dialog open={openRenameDialog} onClose={() => setOpenRenameDialog(false)}>
                    <DialogTitle>Renomear código</DialogTitle>

                    <DialogContent>
                        <TextField autoFocus fullWidth value={renameName} onChange={(e) => setRenameName(e.target.value)} />
                    </DialogContent>

                    <DialogActions>
                        <Button sx={{ color: 'black', backgroundColor: '#939399' }} onClick={() => setOpenRenameDialog(false)}>
                            Cancelar
                        </Button>
                        <Button sx={{ color: 'black', backgroundColor: '#7DC97D' }} variant="contained" onClick={handleRenameCode}>
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Footer */}
                <Box
                    sx={{
                        borderTop: '1px solid #2c2c2c',
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1
                    }}
                >
                    <Button
                        onClick={() => {
                            setNewCodeName('');
                            setOpenNewCodeDialog(true);
                        }}
                        startIcon={<AddIcon />}
                        variant="contained"
                        sx={{
                            backgroundColor: '#2e7d32',
                            '&:hover': { backgroundColor: '#1b5e20' }
                        }}
                        fullWidth
                    >
                        Novo código
                    </Button>

                    <Button onClick={onClose} startIcon={<ArrowBackIcon />} variant="outlined" color="inherit" fullWidth>
                        Voltar
                    </Button>
                </Box>
            </Drawer>
            <Dialog open={openNewCodeDialog} onClose={() => setOpenNewCodeDialog(false)}>
                <DialogTitle>Novo arquivo de código</DialogTitle>

                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Nome do código"
                        placeholder="ex: valida_cliente"
                        value={newCodeName}
                        onChange={(e) => setNewCodeName(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleCreateCode();
                            }
                        }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button sx={{ color: 'black', backgroundColor: '#939399' }} onClick={() => setOpenNewCodeDialog(false)}>
                        Cancelar
                    </Button>
                    <Button
                        sx={{ color: 'black', backgroundColor: '#7DC97D' }}
                        variant="contained"
                        disabled={!newCodeName.trim()}
                        onClick={handleCreateCode}
                    >
                        Criar
                    </Button>
                </DialogActions>
            </Dialog>
            {selectedCode && (
                <Dialog
                    open={Boolean(selectedCode)}
                    onClose={onClose}
                    maxWidth={false}
                    fullWidth
                    disableEnforceFocus
                    disableAutoFocus
                    disableEscapeKeyDown={false}
                    onKeyDownCapture={(e) => {
                        if (e.key === ' ') {
                            e.stopPropagation();
                        }
                    }}
                    PaperProps={{
                        sx: {
                            width: '80vw',
                            height: '80vh',
                            maxWidth: 'none'
                        }
                    }}
                >
                    <DialogTitle>{selectedCode?.name}.js</DialogTitle>

                    <DialogContent
                        disableEnforceFocus
                        disableAutoFocus
                        sx={{
                            padding: 0,
                            height: '100%'
                        }}
                    >
                        <Box sx={{ height: '100%' }} tabIndex={0}>
                            <Editor
                                language="javascript"
                                theme="vs-dark"
                                value={code}
                                onChange={(value) => setCode(value ?? '')}
                                height="100%"
                                onMount={(editor) => {
                                    editor.focus();
                                }}
                                options={{
                                    minimap: { enabled: false },
                                    fontSize: 14,
                                    wordWrap: 'on',
                                    scrollBeyondLastLine: false,
                                    automaticLayout: true
                                }}
                            />
                        </Box>
                    </DialogContent>

                    <DialogActions sx={{ padding: 2 }}>
                        <Button sx={{ color: 'black', backgroundColor: '#939399' }} onClick={handleCloseCodeEditor} color="inherit">
                            Cancelar
                        </Button>
                        <Button sx={{ color: 'black', backgroundColor: '#7DC97D' }} variant="contained" onClick={() => saveCodeFile(code)}>
                            Salvar
                        </Button>
                        <Button
                            sx={{ color: 'black', backgroundColor: '#CF8C8C' }}
                            variant="contained"
                            onClick={() => deleteCodeFile(code)}
                        >
                            Apagar
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
